module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=TR - Turkey.84d4c6c3.svg";